<template>
    <div class="flex md:flex-row flex-col gap-1 md:gap-4 py-4 md:px-4 items-center md:items-start" :class="{ 'cursor-pointer hover:bg-primary-50 rounded-lg': isSelectable }">
        <div>
            <Icon :icon="icon" :variant="iconVariant" />
        </div>
        <div>            
            <div :class="isReverse ? 'text-white' : 'text-gray-800'" class="text-3xl font-headings text-center md:text-left mb-6 md:mb-4" v-html="title"></div>
            <div :class="isReverse ? 'text-gray-300' : 'text-gray-600'" class="mt-0.5"><slot name="description">{{ description }}</slot></div>
        </div>
    </div>
</template>

<script setup>
import Icon from '../Buttons/Icon.vue';

const props = defineProps({
    icon: {
        type: Object,
        required: true
    },
    title: {
        type: String,
        required: true
    },
    subheading: {
        type: String,
        required: false
    },
    description: {
        type: String,
        required: true
    },
    isSelected: {
        type: Boolean,
        default: false
    },
    isSelectable:{
        type: Boolean,
        default: false
    },
    isReverse: {
        type: Boolean,
        default: false
    },
    iconVariant: {
        type: String,
        default: 'primary',
        validator: (value) => ['primary', 'secondary', 'gradient', 'accent'].includes(value)
    }
});
</script>